import { Head, useForm } from "@inertiajs/react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  WeeklyScheduleFields,
  type WeeklySchedule,
} from "@/components/weekly-schedule-fields";
import { Spinner } from "@/components/ui/spinner";
import SettingsLayout from "@/layouts/settings_layout";
import { locationSettingsLocationSchedulePath } from "@/routes";

export default function LocationSchedule({
  location,
  weekly_intervals: weeklyIntervals,
}: {
  location: { id: string; name: string; time_zone: string };
  weekly_intervals: WeeklySchedule;
}) {
  const { t } = useTranslation();
  const form = useForm<{
    location_schedule: { weekly_intervals: WeeklySchedule };
  }>(`location-schedule:${location.id}`, {
    location_schedule: { weekly_intervals: weeklyIntervals },
  });
  const schedule = form.data.location_schedule.weekly_intervals;
  return (
    <SettingsLayout>
      <Head title={`${location.name} · ${t("common.schedule")}`} />
      <h1 className="text-page font-display">{t("common.schedule")}</h1>
      <Card>
        <CardHeader>
          <CardTitle>{t("common.schedule")}</CardTitle>
          <CardDescription>
            {t("settings.schedule_description")} · {location.time_zone}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form
            className="space-y-4"
            onSubmit={(event) => {
              event.preventDefault();
              form.patch(locationSettingsLocationSchedulePath(location.id));
            }}
          >
            <WeeklyScheduleFields
              schedule={schedule}
              onChange={(weekly_intervals) =>
                form.setData("location_schedule", { weekly_intervals })
              }
            />
            {Object.values(form.errors)
              .flat()
              .map((message) => (
                <p
                  key={message}
                  role="alert"
                  className="text-destructive text-sm"
                >
                  {message}
                </p>
              ))}
            <Button type="submit" disabled={form.processing}>
              {form.processing && <Spinner />}
              {t("common.save")}
            </Button>
          </form>
        </CardContent>
      </Card>
    </SettingsLayout>
  );
}
